import React, { ReactElement } from "react";
import { VerantwoordeWoonlasten } from "../../../../../../.generated/rapportage/rapportagetypes";
import TransposedTable from "../../../../components/TransposedTable";
import { Column } from "../../../../components/BaseTable";
import styled from "styled-components";

interface VerantwoordeWoonlastenTabelProps {
  scenarios: VerantwoordeWoonlasten[];
  normJaar: number;
}
const Footnote = styled.p(
  ({ theme }) => `
  margin-left: ${theme.ptom(8)};
  margin-bottom: ${theme.spacing?.l};
`
);

/*istanbul ignore next*/
export const columnsConfig: Column<VerantwoordeWoonlasten>[] = [
  {
    header: "Verantwoorde woonlasten",
    accessor: "scenario",
  },
  {
    header: "Bruto maandinkomen",
    accessor: "brutoInkomenPerMaand",
    dataType: "currency",
  },
  {
    header: "Aantal maal uw inkomen ten opzichte van de geadviseerde hypotheek",
    accessor: (row: VerantwoordeWoonlasten) =>
      row.affordabilityRatio
        ? `${row.affordabilityRatio.toFixed(2)} keer`
        : "-",
  },
  {
    header: "Geadviseerde hypotheek",
    accessor: "geadviseerdeHypotheek",
    dataType: "currency",
  },
  {
    header: "Maximale hypotheek op basis van huidig inkomen en lasten",
    accessor: "maximaleHypotheekInkomen",
    dataType: "currency",
  },
  {
    header: "Maximale verstrekking op basis van het onderpand",
    accessor: "maximaleHypotheekWoningwaarde",
    dataType: "currency",
  },
  {
    header: "Maximale verstrekking met NHG voorwaarden",
    accessor: "maximaleVerstrekkingNhg",
    dataType: "currency",
  },
  {
    header: "Fictieve woonlast per maand",
    accessor: "fictieveMaandlast",
    dataType: "currency",
  },
  {
    header: "Maximale woonlast per maand",
    accessor: "maximaleWoonlast",
    dataType: "currency",
  },
  {
    header: "Werkelijke woonlast per maand",
    accessor: ((row: VerantwoordeWoonlasten) => {
      if (row.werkelijkeBrutomaandlast === null || row.werkelijkeBrutomaandlast === undefined) {
        return null;
      }
      return {
        value: row.werkelijkeBrutomaandlast,
        isOk: row.werkelijkeBrutomaandlast.value > (row.fictieveMaandlast ?? 0) ? false : true
      };
    }) as any,
    dataType: "currency",
  },
];

export const processedScenarios = (scenarios: VerantwoordeWoonlasten[]): VerantwoordeWoonlasten[] => { return scenarios.map((scenario, index) => ({
  ...scenario,
  fictieveMaandlast: index === scenarios.length - 1 ? scenario.fictieveMaandlast : null,
  werkelijkeBrutomaandlast: index === scenarios.length - 1 && scenario.werkelijkeBrutomaandlast !== null
    ? scenario.werkelijkeBrutomaandlast 
    : null,
}));};

export const VerantwoordeWoonlastenTabel = ({
  scenarios,
  normJaar,
}: VerantwoordeWoonlastenTabelProps): ReactElement | null => {
  if (!scenarios || scenarios.length === 0) {
    return null;
  }

  

  return (
    <div className="adv-table-container">
      <TransposedTable<VerantwoordeWoonlasten>
        data={processedScenarios(scenarios)}
        columns={columnsConfig}
        rowLabelColumn="scenario"
        autoAlignCurrency={true}
        className="verantwoorde-woonlasten-transposed-table"
        showCrossOrCheck={true}
      />
      {normJaar && (
        <Footnote id={`footnotes footnote-verantwoorde-woonlasten`}>
          <span className="text-sm text-gray-700">
            {`* Deze berekeningen zijn gebaseerd op de hypotheeknormen van ${normJaar}`}
          </span>
        </Footnote>
      )}
    </div>
  );
};
